module.exports = __webpack_public_path__ + "static/media/fabianCV_es.9c06f61b.pdf";